export default __webpack_public_path__ + "static/media/style11.2db39ecc.jpeg";